import { schemeData, Subscription } from "~/lib";
import { updateDB, getProfile, getByUser } from "~/_server/dynamoDB";
import { padId, RIASRecordType } from ".";
import { createInvoice, sendEmail } from "~/_server";

export const verifyUser = async (userId: number) => {
	"use server";

	try {
		// Set user record to certifier
		await updateDB(`USER#${userId}`, padId(userId, RIASRecordType.USER), {
			status:  "payment-pending",
			role: "certifier",
		});

		const subscriptions = await getByUser( "SUBSCRIPTION", userId, -1 );
		
		await Promise.all(
			subscriptions.items.map( async ( sub: Subscription ) => {

				if (sub.status == "validating") {
					// Create an invoice for joining and the first year's subs
					const invoiceId = await createSubscriptionInvoice(
						sub.scheme,
						parseInt(sub.sk?.replace("SUBSCRIPTION#", "") as string, 10),
						userId,
						true,
					);

					// Set subscription to paying
					await updateDB(sub.pk as string, sub.sk as string, {
						status: "payment-pending",
						invoiceId,
					});

					const user = await getProfile(userId);
					const scheme = schemeData(sub.scheme);

					// Send an email to the user with next steps (payment)
					await sendEmail({
						templateName: "application-verified",
						props: { user: { name: user.firstName }, schemeName: scheme.name, login:"https://rias-regs.co.uk/login" },
						to: user.email,
					});
				}
			}),
		);

		return true;
	} catch (err) {
		console.log("Error verifying user", err);
	}

	return false;
};

export const createSubscriptionInvoice = async (
	schemeSlug: string,
	riasId: number,
	userId: number,
	incJoiningFee: boolean = false,
) => {
	try {
		const user = await getProfile(userId);
		const scheme = schemeData(schemeSlug);

		const lineItems = [];

		if (incJoiningFee) {
			lineItems.push({
				description: `Joining Fee - Certification of Design ${scheme.name}) (#${riasId})`,
				quantity: 1.0,
				unitAmount: scheme.joiningFee,
				accountCode: "203",
				lineAmount: scheme.joiningFee,
			});
		}

		lineItems.push({
			description: `Subscription Fee - Certification of Design ${scheme.name}) (#${riasId})`,
			quantity: 1.0,
			unitAmount: scheme.renewalFee,
			accountCode: "201",
			lineAmount: scheme.renewalFee,
		});

		const invoiceId = await createInvoice(
			user.email,
			`${user.firstName} ${user.lastName}`,
			lineItems,
			riasId,
		);

		return invoiceId;
	} catch (err) {
		console.log("Error creating subscription invoice", err);
	}

	return null;
};
